<template>
    <div>
        <select v-model="selectedValue" class="form-control" :disabled="loading || error" @change="updateValue">
            <option value="" disabled>

        {{this.$t('combobox.titleSelectProkurori')}}
            
            
           </option>
            <option v-for="option in options" :key="option.id" :value="option.id">
                {{ option.name }}
            </option>
        </select>
        <small v-if="loading" class="text-muted">Loading...</small>
        <small v-if="error" class="text-danger">{{ error }}</small>
    </div>
</template>

<script>
import axios from 'axios';
//import authHeader from '@/services/Auth/auth-header';

//const API_URL = process.env.VUE_APP_API_URL + 'group-type/seperate/';
//const API_URL = 'https://prokuroriaapi.cmdsoftwares.com/api/v1/author/combo-box/';


export default {
    name: 'CategoryComboBox',
    props: {
        modelValue: {
            type: [String, Number], // Allow String or Number
            default: '', // Default to empty string for placeholder
        },
        apiUrl: {
            type: String,
            required: true,
        },
    },
    data()
    {
        return {
            options: [],
            loading: false,
            error: null,
            selectedValue: this.modelValue || '', // Use nullish coalescing for safety
            baseUrl: "https://prokuroriaapi.cmdsoftwares.com/api/v1/dashboard/author/combo-box/",
        };
    },
    methods: {
        async fetchOptions()
        {
            this.loading = true;
            this.error = null;
            try
            {
                const response = await axios.get(`${this.baseUrl}${this.apiUrl}`, {
                    //headers: authHeader(),
                });
                // Validate response data
                if (Array.isArray(response.data))
                {
                    this.options = response.data;
                } else
                {
                    throw new Error('Invalid API response: Expected an array');
                }
            } catch (err)
            {
                this.error = 'Failed to load options: ' + (err.response?.data?.message || err.message);
            } finally
            {
                this.loading = false;
            }
        },
        updateValue()
        {
            this.$emit('update:modelValue', this.selectedValue);
        },
    },
    created()
    {
        this.fetchOptions();
    },
    watch: {
        modelValue(newValue)
        {
            this.selectedValue = newValue ?? ''; // Ensure empty string if null/undefined
        },
        apiUrl()
        {
            this.fetchOptions();
        },
    },
};
</script>

<style scoped>
.form-control {
    width: 100%;
    /* Custom arrow down */
    background: url('data:image/svg+xml;utf8,<svg fill="%23666" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 0.75rem center/1.2em auto;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 2.5em;
}
</style>